import { useEffect, useState } from "react"
import { Box, Button } from "@mui/material"
import "./index.css" // Renamed to a more generic name
import Loader from "../GlobalComponents/Loader"
import ArrowBackIcon from "@mui/icons-material/ArrowBack"
import OTPInput from "react-otp-input"
import { useLocation, useNavigate } from "react-router-dom"
import { verifyOtp } from "../../services/services"
import { showToast } from "../GlobalComponents/Toast"

function OtpScreen() {
  const [otp, setOtp] = useState("")
  const [isLoading, setIsLoading] = useState(false)
  const [showResend, setShowResend] = useState(true)
  const [intervalId, setIntervalId] = useState(null)

  const stateDetails = useLocation()?.state

  const [timer, setTimer] = useState(120)
  const enableLogin = otp?.toString()?.length < 6
  const navigate = useNavigate()

  useEffect(() => {
    if (showResend) return

    const id = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(id)
          setShowResend(true)
          return 120
        }

        return prev - 1
      })
    }, 1000)

    setIntervalId(id)

    return () => clearInterval(id)
  }, [showResend])

  const validateChar = (text) => {
    const isString = typeof text === "string"
    const isNumber = typeof text === "number"

    return (isNumber || (isString && text !== "")) && !isNaN(Number(text))
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    setIsLoading(true)

    const data = await verifyOtp({ email: stateDetails?.email, otp })
    console.log("data", data)
    if (data?.status !== "Success") {
      let message = data.message
      showToast("error", message)
    } else {
      navigate("/changePassword", { state: { email: stateDetails?.email } })
    }

    setIsLoading(false)
  }

  return (
    <Box className="login-wrapper">
      <Box className="login-container">
        {/* Left Sidebar with Background */}
        <Box className="sidebar-container" />

        {/* Login Form */}
        <Box className="form-container">
          {isLoading && <Loader />}
          <form onSubmit={handleSubmit} className="login-form">
            <Button
              className="back_button_top"
              onClick={() => navigate("/forgotPassword")}
            >
              <ArrowBackIcon className="back_icon" />
              <span className="backBtn">Back</span>
            </Button>
            <h1 className="form-header">OTP</h1>
            <p className="auth_description">A code has been sent to Email</p>

            <div className="form-group" style={{ marginBottom: 20 }}>
              <OTPInput
                value={otp}
                onChange={setOtp}
                numInputs={6}
                renderSeparator={<div style={{ margin: "5px" }}></div>}
                renderInput={(props) => (
                  <input
                    {...props}
                    containerStyle={{
                      //   height: "2300px",
                      //   width: "2300px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                    }}
                    style={{
                      height: "42px",
                      width: "42px",
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      textAlign: "center",
                      fontSize: "20px",
                    }}
                  />
                )}
              />
            </div>

            <Button
              type="submit"
              variant="contained"
              className="submit-button"
              disabled={enableLogin}
              sx={{
                backgroundColor: enableLogin ? "gray" : "#3083EF",
                color: "white",
              }}
            >
              Verify
            </Button>

            {/* <p
              className="forgot_password"
              style={{ color: "#3083EF", cursor: "pointer" }}
              // onClick={handleResendClick}
            >
              {showResend ? "Resend OTP" : `Resend OTP in ${timer}s`}
            </p> */}
          </form>
        </Box>
      </Box>
    </Box>
  )
}

export default OtpScreen
